import { GetMeinOrtPostsLocalNewsPostFilterEnum } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useState } from 'react';

import { useGetMeinOrtPosts } from '@/features/api/hooks/grapevine-post/useGetMeinOrtPosts';
import { MeinOrtNewsFilter } from '@/features/mein-ort/components/news-filter/newsFilterTypes';
import { useGetMeinOrtPostsParams } from '@/features/posts/hooks/useGetPostsParams';
import { PostFeedType } from '@/features/posts/types/postFeed';

export const useMeinOrtNewsFeed = (enabled: boolean) => {
  const [newsFilter, setNewsFilter] = useState<MeinOrtNewsFilter>(
    MeinOrtNewsFilter.ALLE
  );

  const meinOrtParams = useGetMeinOrtPostsParams(PostFeedType.NEWS_ITEM, {
    localNewsPostFilter: getLocalNewsPostFilter(newsFilter)
  });

  const query = useGetMeinOrtPosts(meinOrtParams, enabled);

  return { newsFilter, setNewsFilter, params: meinOrtParams, query };
};

const getLocalNewsPostFilter = (filter: MeinOrtNewsFilter) => {
  switch (filter) {
    case MeinOrtNewsFilter.RATHAUS: {
      return GetMeinOrtPostsLocalNewsPostFilterEnum.Rathaus;
    }
    case MeinOrtNewsFilter.GEMEINDE: {
      return GetMeinOrtPostsLocalNewsPostFilterEnum.Gemeinde;
    }
    case MeinOrtNewsFilter.ALLE: {
      return GetMeinOrtPostsLocalNewsPostFilterEnum.All;
    }
  }
};
